// extracted by mini-css-extract-plugin
export default {"form":"NewPostForm_form__l+7JQ","control":"NewPostForm_control__a4Sgg","actions":"NewPostForm_actions__uVQT-"};